 

import Message_root from "./message_root/message";
import Error_page from "./pages/error";
import Community from "./community_root/community";
import Account from "./profile/account";

import Login from "./profile/login"; 
//select-company
import Select_company from "./accounts_authority_root/select-company";
import Services from "./services_root/services";  
import Install_app from "./body_root/install-app";
import Chart_root from "./cart_root/chart";
import Search_root from "./search_root/search";
import Home_page from "./home_root/home";

import Pricing from "./home_root/pricing";
//tools free tools imports
import Phonebook from "./tools_root/phonebook_root/phonebook";
import ImageToPDF from "./tools_root/image-to-pdf_root/image-to-pdf";
import FaviconGenerator from "./tools_root/favicon_root/favicon-generator";
import Word_counter from "./tools_root/word-counter_root/word-counter";
import Typing_master from "./tools_root/typing_master_root/typing-master";
//support and dashboard
import Support from "./support_root/support"; 
import Dashboard from "./dashboard_root/dashboard";
import Create_company from "./services_root/create-company";
//company root
import Company_services from "./company_root/company";
//website root
import Website_root from "./website_root/website";

//home root
import Compare from "./home_root/compare";
//payment-gateway
import Payment_gateway from "./home_root/payment-gateway";
//cart and category
import Catagry_view from "./view_root/category";
import Checkout from "./cart_root/checkout";
import FilterItems from "./filter_root/filter";  
import Accounting from "./accounting_root/accounting";
import Sitemap from "./body_root/sitemap";
import Upload_dock from "./accounting_root/print_root/upload-dock";
//POS report
import Pos_receipt_page from "./pos-receipt_root/pos-receipt";
//pos billing
import Pos_billing_page from "./pos_billing_root/pos-billing";
//about page

import About_page from "./home_root/about"; 
import Website_development_services from "./services_root/website-development";

 
export const Approutes = [
  { path: '/', name: 'Home Apps', element: <Accounting /> },
     { path: '/home', name: 'Home', element: <Home_page/> },  
          { path: '/pricing', name: 'Pricing', element: <Pricing/> },
   { path: '/website-development', name: 'Website Development', element: <Website_development_services/> },
   { path: '/website', name: 'Website', element: <Website_root/> },
   //Select_company
   { path: '/select-company', name: 'Select Company', element: <Select_company /> },
   //staff payments
   { path: '/pos-receipt', name: 'Pos receipt', element: <Pos_receipt_page/> },
   //pos billing
   { path: '/pos-billing', name: 'Pos billing', element: <Pos_billing_page/> },
 { path: '/upload-dock', name: 'Upload dock', element: <Upload_dock/> },
        { path: '/sitemap', name: 'Sitemap', element: <Sitemap /> }, 
  { path: '/accounting', name: 'accounting', element: <Accounting/> },
    { path: '/compare', name: 'compare', element: <Compare /> },
  { path: '/create-company', name: 'Create company', element: <Create_company /> },
    { path: '/company', name: 'Company', element: <Company_services /> },
  { path: '/dashboard', name: 'Dashboard', element: <Dashboard /> },
  { path: '/category', name: 'Category View', element: <Catagry_view /> },
  { path: '/filter', name: 'Filter Items', element: <FilterItems/> }, 
  { path: '/support', name: 'Support', element: <Support /> },
  { path: '/search', name: 'search', element: <Search_root /> },
  { path: '/chart', name: 'Chart', element: <Chart_root /> },
  { path: '/checkout', name: 'Checkout', element: <Checkout /> },
  { path: '/install-app', name: 'Install App', element: <Install_app /> },  
  { path: '/services', name: 'Services', element: <Services /> }, 
  { path: '/message', name: 'Message', element: <Message_root /> },
  { path: '/community', name: 'Message', element: <Community /> },
  { path: '/account', name: 'Profile account', element: <Account /> },
  { path: '/login', name: 'Login account', element: <Login /> },
  //payment-gateway
  { path: '/payment-gateway', name: 'Payment Gateway', element: <Payment_gateway /> },
  //toos free tools routes
   { path: '/phonebook', name: 'Phonebook', element: <Phonebook /> },
   { path: '/image-to-pdf', name: 'Image To PDF', element: <ImageToPDF /> },
   { path: '/favicon-generator', name: 'Favicon Generator', element: <FaviconGenerator /> },
   { path: '/word-counter', name: 'Word Counter', element: <Word_counter /> },
   { path: '/typing-master', name: 'Typing Master', element: <Typing_master /> },
  { path: '/error', name: 'error', element: <Error_page /> }

];